import { useEffect, useMemo, useState } from "react";
import { breakpoints } from "./breakpoints";
export interface IBreakpoint {
  value: number;
  name: string;
}

const allBreakpoints = [
  ...breakpoints.mobile,
  ...breakpoints.tablet,
  ...breakpoints.desktop,
];

const getPlatformAndLimit = (width: number): [number, number] => {
  if (width > 1920) {
    return [width, 1920];
  }
  // Замена reduce на findIndex, потому что reduce здесь избыточен и работает некорректно: он может возвращать неправильный индекс при некоторых значениях width (например, 414). findIndex проще и точнее определяет первый брейкпоинт, превышающий width
  const index = allBreakpoints.findIndex(c => width <= c);

  return [allBreakpoints[index], allBreakpoints[index - 1] || 0];
};

interface IReturned {
  readonly upperLimit: IBreakpoint;
  readonly lowerLimit: IBreakpoint;
  readonly currentWidth: number;
}

export const useBreakpointData = (): IReturned => {
  const [width, setWidth] = useState<number>(1920);

  const [upperValue, lowerValue] = getPlatformAndLimit(width);

  useEffect(() => {
    const handleResize = (): void => {
      setWidth(window.innerWidth);
    };
    setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    currentWidth: width,
    upperLimit: {
      name: `breakpoint-${upperValue}`,
      value: upperValue,
    },
    lowerLimit: {
      name: `breakpoint-${lowerValue}`,
      value: lowerValue,
    },
  };
};

const useBreakpoint = (breakpoint: string): boolean => {
  const {
    upperLimit: { value },
  } = useBreakpointData();
  return useMemo(() => {
    return value <= Number(breakpoint.split("-")[1]);
  }, [value]);
};

export default useBreakpoint;
